// extracted by mini-css-extract-plugin
export default {"wallet":"Wallet_wallet__+EdKo","wallet__container":"Wallet_wallet__container__lftPK","wallet__title":"Wallet_wallet__title__lDcaq","wallet__text":"Wallet_wallet__text__X8seW"};